import React, { Component } from "react";
import OutlinedDiv from "../Styles/OutlinedDiv";
import DataStore from "./../../../stores/DataStore";
import { observer } from "mobx-react";
/**
 * @class AttributeCollection
 * Attributsammlung
 * Vorallem zu (evtl) strukturierung von Attributen innerhalb eines Themas
 * oder zur Nutzung für andere Attribute z.b. SliderGroup
 *  @implements {Attribute}
 */
class AttributeCollection extends Component {
  constructor(params) {
    super(params);
    this.DataStore = DataStore;
  }

  componentDidMount() {}

  getValue() {
    const {
      attribute: {
        attributeOption: { attributes = [] },
      },
    } = this.props;
    if (this.attributeModuls) {
      const values = [];
      attributes.forEach((atr) =>
        values.push({
          key: atr.id,
          value: this.DataStore.attributeValues[atr.id].value,
        })
      );
      return values;
    }
    return null;
  }

  getValuePlain() {
    return this.getValue().map((o) => o.value);
  }

  getValueString() {
    return this.attributes
      .map((atr) => DataStore.attributeValues[atr.id].modul.getValueString())
      .join();
  }

  getSummaryDisplay() {
    return (
      <div
        style={{
          borderStyle: "solid",
          borderWidth: "1px",
          borderRadius: "5px",
          borderColor: "lightgrey",
          minHeight: "50px",
          display: "flex",
          flexDirection: "column",
          padding: "5px",
          width: "100%",
        }}
      >
        {this.attributes.map((atr) =>
          DataStore.attributeValues[atr.id].modul.getSummaryDisplay()
        )}
      </div>
    );
  }
  prepareAttributeConfigs() {
    const {
      attribute: {
        id = "",
        attributeOption: { attributes = [] },
      },
    } = this.props;
    const attributeState = this.DataStore.attributeValues[id];
    attributes.forEach((atr) => {
      atr = atr.readOnly ? atr.readOnly : attributeState.readOnly;
      atr = atr.required ? atr.required : attributeState.required;
    });
  }

  getAttributes() {
    const {
      attribute: {
        attributeOption: { attributes = [] },
      },
      AtrModClass,
    } = this.props;
    this.attributeModuls = [];
    this.prepareAttributeConfigs();
    attributes.forEach((atr) => {
      this.attributeModuls.push(
        <AtrModClass
          attribute={atr}
          messageHandler={this.messageHandler}
          key={this.id + atr.id}
        />
      );
    });
    return this.attributeModuls;
  }

  render() {
    const {
      attribute: {
        name = "",
        attributeOption: { attributes = [], WrapperDiv = OutlinedDiv },
        attributeModul,
      } = {},
    } = this.props;
    attributeModul.holdedAttribute = this;
    this.messageHandler = DataStore.getHandler().messageHandler;
    this.messageHandler.logDebugFormatted(
      "AttributeCollection",
      "render",
      "",
      this.props,
      this.state,
      this.attributeModuls
    );
    return (
      <div>
        <WrapperDiv
          label={name}
          style={{
            flexGrow: 1,
            marginRight: "5px",
          }}
        >
          {this.getAttributes()}
        </WrapperDiv>
      </div>
    );
  }
}

export default observer(AttributeCollection);
